import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'numToDays'
})
export class NumToDaysPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    if (value === 0 || value === 1) {
      return value + ' day';
    } else {
      return value + ' days';
    }
  }

}
